/** Digby: moving, digging, collecting, pushing, snapping, leaving (docs/spec/02 §4). */

import { E } from '../elements';
import { at, isSpace, move, put, store } from '../grid';
import { RULES } from '../tuning';
import type { CaveState, Input } from '../types';
import { DIR_LEFT, DIR_NONE, DIR_RIGHT, DX, DY } from '../types';
import { openDoors } from './deep';

export function openGate(s: CaveState): void {
  if (s.gateOpen) return;
  s.gateOpen = true;
  for (let i = 0; i < s.cells.length; i++) if (s.cells[i] === E.OUTBOX_CLOSED) s.cells[i] = E.OUTBOX_OPEN;
  s.events.push({ type: 'gateOpen' });
}

function collectDiamond(s: CaveState, x: number, y: number): void {
  s.score += s.gateOpen ? s.params.extraValue : s.params.diamondValue;
  s.diamonds++;
  s.events.push({ type: 'collect', x, y, what: 'diamond' });
  if (s.diamonds >= s.params.diamondsNeeded) openGate(s);
}

/** Take a pickup at (x, y) if there is one there; true if taken. The cell is left as it was. */
function take(s: CaveState, x: number, y: number, el: number): boolean {
  if (el === E.DIAMOND) collectDiamond(s, x, y);
  else if (el >= E.KEY && el < E.KEY + 3) {
    s.events.push({ type: 'collect', x, y, what: 'key' });
    openDoors(s, el - E.KEY);
  } else if (el === E.CLOCK) {
    s.timeLeft += RULES.clockBonus;
    s.events.push({ type: 'collect', x, y, what: 'clock' });
  } else if (el === E.DIRT) s.events.push({ type: 'dig', x, y });
  else return false;
  return true;
}

export function digby(s: CaveState, x: number, y: number, input: Input): void {
  const d = s.digby;
  d.moving = false;
  d.pushing = false;
  d.x = x;
  d.y = y;
  if (s.status !== 'playing') return;
  const dir = input.dir;
  if (dir === DIR_NONE) {
    d.idle++;
    return;
  }
  if (dir === DIR_LEFT) d.facing = -1;
  else if (dir === DIR_RIGHT) d.facing = 1;
  d.idle = 0;
  const tx = x + (DX[dir] ?? 0);
  const ty = y + (DY[dir] ?? 0);
  const target = at(s, tx, ty);

  if (input.fire) {
    if (take(s, tx, ty, target)) store(s, tx, ty, E.SPACE);
    return;
  }
  if (target === E.SPACE || take(s, tx, ty, target)) {
    move(s, x, y, dir, E.DIGBY);
    d.moving = true;
    d.x = tx;
    d.y = ty;
    return;
  }
  if (target === E.BOULDER && (dir === DIR_LEFT || dir === DIR_RIGHT)) {
    const bx = tx + (DX[dir] ?? 0);
    d.pushing = true;
    if (isSpace(s, bx, ty) && s.rng.oneIn(RULES.pushOneIn)) {
      move(s, tx, ty, dir, E.BOULDER);
      move(s, x, y, dir, E.DIGBY);
      d.moving = true;
      d.x = tx;
      s.events.push({ type: 'push', x: bx, y: ty });
    }
    return;
  }
  if (target === E.OUTBOX_OPEN) {
    put(s, x, y, E.SPACE);
    d.x = tx;
    d.y = ty;
    d.moving = true;
    s.status = 'won';
    s.events.push({ type: 'won', x: tx, y: ty });
  }
}
